var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"pa-4",attrs:{"outlined":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }